import Twemoji from "../../Twemoji";

export const species = {
  dog: {
    displayName: "Dog",
    icon: "🐶",
  },
  cat: {
    displayName: "Cat",
    icon: "🐱",
  },
  horse: { displayName: "Horse", icon: "🐴" },
  goat: { displayName: "Goat", icon: "🐐" },
  cow: { displayName: "Cow", icon: "🐮" },
  pig: { displayName: "Pig", icon: "🐷" },
  fowl: { displayName: "Fowl", icon: "🐔" },
  sheep: { displayName: "Sheep", icon: "🐑" },
  "mouse/rat/gerbil": {
    displayName: "Mouse/Rat/Gerbil",
    icon: "🐭",
  },
  "chinchilla/hamster/guineapig": {
    displayName: "Hamster/Chinchilla/Guinea Pig",
    icon: "🐹",
  },
  "rabbit/lagomorph": {
    displayName: "Rabbit/Lagomorph",
    icon: "🐰",
  },
  bird: {
    displayName: "Bird",
    icon: "🦜",
  },
  fish: {
    displayName: "Fish",
    icon: "🐠",
  },
  "reptile/amphibian": {
    displayName: "Reptile/Amphibian",
    icon: "🦎",
  },
  snake: {
    displayName: "Snake",
    icon: "🐍",
  },
  spider: { displayName: "Spider", icon: "🕷" },
  other: { displayName: "Other", icon: "🦄" },
};

export function getSpeciesLabel(displayName, emoji) {
  return (
    <h5 className="text-sm">
      {displayName} <Twemoji emoji={emoji} />
    </h5>
  );
}

export function getPatientIntactText({
  intact,
  sex,
  isForEdit = false,
}) {
  // Sex is optional on a patient. Without it we cannot say spayed vs neutered,
  // so report no altered status rather than a misleading default.
  if (sex !== "f" && sex !== "m") {
    return "";
  }

  if (intact && !isForEdit) {
    return "Intact";
  }

  if (sex === "f") {
    return "Spayed";
  } else {
    return "Neutered";
  }
}

/**
 * Display value for a patient's age. The backend returns the literal
 * "Age not specified" when a patient has no birthday; treat that (and
 * empty/null) as unrecorded. Pass fallback="" where the caller renders its
 * own placeholder (e.g. the Signalment tab's italic "Not recorded").
 */
export function formatPatientAge(age, fallback = "Not recorded") {
  return age && age !== "Age not specified" ? age : fallback;
}
